/**
 * Created by mkoehler on 09.02.16.
 */
import { OndigoNS } from '../modules/main.js';

!function ($) {
    // Class Definition
    OndigoNS.Reference = function (element) {
        this.$referenceDetail = $(element);
        this.$backLink = $('.backLink', this.$referenceDetail);

        this.init();
    };

    OndigoNS.Reference.prototype = {
        init: function () {
            this.handleDetailBacklink();
        },
        handleDetailBacklink : function () {
            this.$backLink.on('click', function (e) {
                if(document.referrer == (window.location.protocol + '//' + window.location.host + $(this).attr('href'))) {
                    window.history.back();
                    e.preventDefault();
                    return;
                }
            });
        }
    };

    // plugin definition
    $.fn.referenceHandler = function () {
        return new OndigoNS.Reference(this);
    };
    $.fn.referenceHandler.Constructor = OndigoNS.Reference;

}(window.jQuery);


$(document).ready(function () {

    var $referenceDetail = $('.referenceDetail');
    if ($referenceDetail.length) {
        $referenceDetail.referenceHandler();
    }
});